<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->

<div [id]="containerId" class="m-viewport"></div>
<gh-ext-preloader class="m-preloader stretch" [loading]="loading"></gh-ext-preloader>